import React from "react";

const InformationOfficers = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>
          The Names, Designations & other particulars of Public Information
          Officers
        </h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "justify" }}
      >
        <h6>AUTHORITIES UNDER RIGHT TO INFORMATION ACT, 2005.</h6>

        <div className="table-responsive">
        <table className="table table-striped table-bordered">
         
            <tbody>
              <tr>
                <th colspan="2">FIRST APPELLATE AUTHORITY</th>
                <th>COMPANY SECRETARY</th>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td className="bold">Public Information Officer</td>
                <td className="bold">Asstt. Public Information Officer</td>
              </tr>
              <tr>
                <td className="bold">Head Office</td>
                <td>Chief Finance &amp; Accounts Officer</td>
                <td>Assistant Purchase Officer</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="table-responsive">
        <table className="table table-striped table-bordered">
         
            <tbody>
              <tr>
                <th colspan="5" id="12345" scope="col">
                  REGIONAL OFFICES/MARKETING OFFICE
                </th>
              </tr>
              <tr>
                <td className="bold" colspan="2">
                  HISAR
                </td>
                <td className="bold" colspan="">
                  Name of officer
                </td>
                <td className="bold" colspan="">
                  Office
                </td>
                <td className="bold" colspan="">
                  Residence
                </td>
              </tr>
              <tr>
                <td>Unit Incharge</td>
                <td>Public Information Officer</td>
                <td>Mahabir Singh</td>
                <td>01662-275065</td>
                <td>9813854429</td>
              </tr>
              <tr>
                <td>Accounts Officer/Section Officer Accounts Asstt.</td>
                <td>Asstt. Public Information Officer</td>
                <td>Mohan Sura</td>
                <td>01662-275065</td>
                <td>9416695919</td>
              </tr>
              <tr>
                <td className="bold" colspan="2">
                  SIRSA
                </td>
                <td className="bold" colspan="">
                  &nbsp;
                </td>
                <td className="bold" colspan="">
                  &nbsp;
                </td>
                <td className="bold" colspan="">
                  &nbsp;
                </td>
              </tr>
              <tr>
                <td>Unit Incharge</td>
                <td>Public Information Officer</td>
                <td>Bharat Singh Dhaka</td>
                <td>01666-243297</td>
                <td>
                  9468054176,
                  <br /> 7988651861
                </td>
              </tr>
              <tr>
                <td>Accounts Officer/Section Officer</td>
                <td>Asstt. Public Information Officer</td>
                <td>Jaidev Dahiya</td>
                <td>01666-243297</td>
                <td>9416119848</td>
              </tr>
              <tr>
                <td className="bold" colspan="2">
                  PATAUDI
                </td>
                <td className="bold" colspan="">
                  &nbsp;
                </td>
                <td className="bold" colspan="">
                  &nbsp;
                </td>
                <td className="bold" colspan="">
                  &nbsp;
                </td>
              </tr>
              <tr>
                <td>Unit Incharge</td>
                <td>Public Information Officer</td>
                <td>Jaibir singh</td>
                <td>0124-2672847</td>
                <td>9992110635</td>
              </tr>
              <tr>
                <td>Accounts Officer/Section Officer</td>
                <td>Asstt. Public Information Officer</td>
                <td>Rahul Singla</td>
                <td>0124-2672847</td>
                <td>9541868584</td>
              </tr>
              <tr>
                <td className="bold" colspan="2">
                  TOHANA
                </td>
                <td className="bold" colspan="">
                  &nbsp;
                </td>
                <td className="bold" colspan="">
                  &nbsp;
                </td>
                <td className="bold" colspan="">
                  &nbsp;
                </td>
              </tr>
              <tr>
                <td>Unit Incharge</td>
                <td>Public Information Officer</td>
                <td>Rahuldeep Rana</td>
                <td>01692-220879</td>
                <td>9991091214</td>
              </tr>
              <tr>
                <td>Accounts Officer/Section Officer</td>
                <td>Asstt. Public Information Officer</td>
                <td>Jaidev Dahiya</td>
                <td>01692-220879</td>
                <td>9416119848</td>
              </tr>
              <tr>
                <td className="bold" colspan="2">
                  YAMUNA NAGAR
                </td>
                <td className="bold" colspan="">
                  &nbsp;
                </td>
                <td className="bold" colspan="">
                  &nbsp;
                </td>
                <td className="bold" colspan="">
                  &nbsp;
                </td>
              </tr>
              <tr>
                <td>Unit Incharge</td>
                <td>Public Information Officer</td>
                <td>S.P. Singh</td>
                <td>01732-250391</td>
                <td>9416388861</td>
              </tr>
              <tr>
                <td>Accounts Officer/Section Officer</td>
                <td>Asstt. Public Information Officer</td>
                <td>Suresh Pal</td>
                <td>01732-250391</td>
                <td>9467587342</td>
              </tr>
              <tr>
                <td className="bold" colspan="2">
                  UMRI
                </td>
                <td className="bold" colspan="">
                  &nbsp;
                </td>
                <td className="bold" colspan="">
                  &nbsp;
                </td>
                <td className="bold" colspan="">
                  &nbsp;
                </td>
              </tr>
              <tr>
                <td>Unit Incharge</td>
                <td>Public Information Officer</td>
                <td>S.P. Singh</td>
                <td>01744-230339</td>
                <td>9416388861</td>
              </tr>
              <tr>
                <td>Accounts Officer/Section Officer</td>
                <td>Asstt. Public Information Officer</td>
                <td>Suresh Pal</td>
                <td>01744-230339</td>
                <td>9467587342</td>
              </tr>
              <tr>
                <td className="bold" colspan="2">
                  BHIWANI
                </td>
                <td className="bold" colspan="">
                  &nbsp;
                </td>
                <td className="bold" colspan="">
                  &nbsp;
                </td>
                <td className="bold" colspan="">
                  &nbsp;
                </td>
              </tr>
              <tr>
                <td>Unit Incharge</td>
                <td>Public Information Officer</td>
                <td>Lalet</td>
                <td>01664-242243</td>
                <td>9467396381</td>
              </tr>
              <tr>
                <td>Accounts Officer/Section Officer</td>
                <td>Asstt. Public Information Officer</td>
                <td>Babita</td>
                <td>01664-242243</td>
                <td>8607620505</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default InformationOfficers;
